import { Injectable } from '@angular/core';
import { Navigator, NavigatorHelperBase } from '@kpd/framework-ngx';
import { RoleKey } from 'app/shared/models/keys/role-key';

@Injectable()
export class RolesNavigatorHelper extends NavigatorHelperBase {
  constructor(navigator: Navigator) {
    super(navigator);
  }
  composeOverviewUrl(): string {
    return `roles`;
  }
  composeDetailUrl(key: RoleKey): string {
    return `roles/details/application/${key.application}/role/${key.name}`;
  }

  composeCreateUrl(): string {
    return `roles/details/application/0/role/0`;
  }
}
